function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.708.333H1.292a.625.625 0 00-.625.625v12.084c0 .345.28.625.625.625h15.416c.345 0 .625-.28.625-.625V.958a.625.625 0 00-.625-.625zm-.625 1.25v.263L9 6.692 1.917 1.846v-.263h14.166zM1.917 12.417V3.36l6.73 4.605a.624.624 0 00.706 0l6.73-4.605v9.056H1.917z",
  fill: "#23448D"
})));